export const UserCardDetailsActionType =
		{
			SET_USER_CARD_DETAILS: "SET_USER_CARD_DETAILS",
		};
